(function () {
  function initBtnControl() {
    const form = document.querySelector('product-form form');
    if (!form) return;

    const submitBtn = form.querySelector('.product-form__submit');
    const btnText = form.querySelector('.btn-main-text');
    if (!submitBtn || !btnText) return;

    const variantInput = form.querySelector('input[name="id"], input.product-variant-id');

    // ── 初始状态：强制禁用按钮 ──
    submitBtn.disabled = true;
    btnText.textContent = 'Select Color & Size';

    // ── 延迟清除 Kaching 预选（等待 Kaching 渲染完成）──
    setTimeout(function () {
      // 清除 Dawn 原生 radio 预选
      form.querySelectorAll('input[type="radio"]').forEach(r => (r.checked = false));
      form.querySelectorAll('select').forEach(s => (s.selectedIndex = -1));

      // 清除 variant input 值
      if (variantInput) variantInput.value = '';

      // 再次确保按钮禁用
      submitBtn.disabled = true;
      btnText.textContent = 'Select Color & Size';
    }, 800);

    // ── 监听 Dawn 原生 variant:change 事件 ──
    document.addEventListener('variant:change', function (e) {
      const variant = e.detail && e.detail.variant;
      if (variant) {
        handleVariantSelected(variant.price, variant.available);
      } else {
        resetBtn();
      }
    });

    // ── setInterval 轮询 variantInput 值变化（兼容 Kaching）──
    let lastVariantId = '';
    setInterval(function () {
      const currentId = variantInput ? variantInput.value : '';
      if (currentId !== lastVariantId) {
        lastVariantId = currentId;
        if (currentId) {
          fetchAndUpdate(currentId);
        } else {
          resetBtn();
        }
      }
    }, 300);

    // ── 监听表单 change 事件（兜底）──
    form.addEventListener('change', function () {
      const currentId = variantInput ? variantInput.value : '';
      if (currentId) {
        fetchAndUpdate(currentId);
      } else {
        resetBtn();
      }
    });

    function fetchAndUpdate(variantId) {
      const handle = getProductHandle();
      if (!handle) return;
      fetch('/products/' + handle + '.js')
        .then(r => r.json())
        .then(product => {
          const variant = product.variants.find(v => String(v.id) === String(variantId));
          if (variant) {
            handleVariantSelected(variant.price, variant.available);
          } else {
            resetBtn();
          }
        });
    }

    function handleVariantSelected(price, available) {
      if (!available) {
        submitBtn.disabled = true;
        btnText.textContent = 'Sold Out';
        return;
      }
      submitBtn.disabled = false;
      btnText.textContent = 'Add to Cart';
    }

    function resetBtn() {
      submitBtn.disabled = true;
      btnText.textContent = 'Select Color & Size';
    }

    function getProductHandle() {
      const match = window.location.pathname.match(/\/products\/([^/?]+)/);
      return match ? match[1] : null;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBtnControl);
  } else {
    initBtnControl();
  }
})();
